import React, { createContext, useContext, useMemo, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
const OCCContext = /*#__PURE__*/createContext();
export const OCCProvider = ({
  children
}) => {
  const location = useLocation();
  const [emailObj, setEmailObj] = useState(null);
  const [savedPreferences, setSavedPreferences] = useState(null);
  const [initialPreferences, setInitialPreferences] = useState(null);
  const params = useMemo(() => {
    const urlParams = new URLSearchParams(location.search);
    const parsed = {};
    urlParams.forEach((value, key) => {
      parsed[key] = value;
    });
    return parsed;
  }, [location.search]);
  const value = useMemo(() => ({
    params,
    emailObj,
    setEmailObj,
    savedPreferences,
    setSavedPreferences,
    initialPreferences,
    setInitialPreferences
  }), [params, emailObj, savedPreferences, initialPreferences]);
  return /*#__PURE__*/React.createElement(OCCContext.Provider, {
    value: value
  }, children || /*#__PURE__*/React.createElement(Outlet, null));
};
// custom hook (clean usage)
export const useOCC = () => useContext(OCCContext);